import { useIntervalFn } from '@vueuse/core'
import { ref } from 'vue'
export default function countDown() {
  const time = ref(0)
  const { pause, resume } = useIntervalFn(
    () => {
      if (time.value > 0) {
        time.value--
      } else {
        pause()
      }
    },
    1000,
    { controls: true }
  )
  const start = (num) => {
    time.value = num
    resume()
  }
  return { time, start }
}
